<template>
    <div>
        <v-card dark class="pa-4 grey darken-3 ma-4">
            <v-toolbar dark flat dense class="grey darken-3">
                <v-toolbar-title>Пакетний продаж Youtv</v-toolbar-title>
            </v-toolbar>
            <!-- {{ f.contractor_id }} -->
            <!-- <v-btn color="cardheader" text @click="getUsers()">Обрати користувача</v-btn> -->

            <!-- <v-alert type="error" v-if="f.id && !userData.contractor">У користувача не вибран контрагент! Прожаж неможливий!</v-alert> -->
            
            <v-card-text>
                <v-flex xs4 lg1>
                    <v-text-field v-model="f.id" label="ID користувача" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-text-field v-model="f.fio" label="ПІБ користувача" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <v-text-field v-model="f.phone" label="Телефон користувача" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 lg6>
                    <!-- <v-text-field v-model="f.contractor" label="Контрагент користувача" readonly></v-text-field> -->
                    <v-autocomplete v-model="f.contractor_id" :loading="loading" :items="items"
                        :search-input.sync="search" cache-items flat hide-no-data hide-details
                        label="Контрагент користувача"></v-autocomplete>

                </v-flex>
                <v-flex xs12 lg6>
                    <v-radio-group v-model="f.shopId" mandatory>
                        <v-radio :value="-1" label="Службова ТТ"></v-radio>
                    </v-radio-group>

                </v-flex>

                <v-subheader>Продати пакети Youtv</v-subheader>
                <v-flex xs12 lg6>
                    <v-simple-table dark>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Пакет
                                    </th>
                                    <th class="text-left">
                                        Доступно
                                    </th>
                                    <th class="text-left">
                                        Продати
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in availList" :key="item.name">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.avail }}</td>
                                    <td><input v-model="item.cnt"
                                            :class="item.cnt > item.avail ? `inp-cnt error` : `inp-cnt`"></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="grey" @click="goBack()">
                    <v-icon color="grey">mdi-keyboard-return</v-icon> Повернутись
                </v-btn>
                <v-btn text v-if="f.contractor_id && wasSelectedPacks" color="youtv" @click="sendForm()">
                    Продати коди
                </v-btn>
            </v-card-actions>

        </v-card>
        <v-dialog v-model="successB" max-width="500">
            <v-card>
                <v-system-bar>
                    <v-spacer></v-spacer>
                    <v-icon @click="successB = false">mdi-close</v-icon>
                </v-system-bar>
                <v-card-text>
                    <h5>Успішно продано пакети Youtv</h5>
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="youtv" @click="successB = false">
                        Закрити
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog scrollable v-model="usersTable" max-width="1600">
            <v-card>
                <v-system-bar>
                    <v-spacer></v-spacer>
                    <v-icon @click="usersTable = false">mdi-close</v-icon>
                </v-system-bar>
                <v-toolbar flat dense class="">
                    <v-toolbar-title>Обрати користувача</v-toolbar-title>
                    <v-card-title class="headline"></v-card-title>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-account-search" label="Пошук" single-line
                        hide-details></v-text-field>
                </v-toolbar>
                <v-card-text>
                    <v-data-table :headers="headers" :items="list" :footer-props="footerProps" :search="search"
                        class="ma-4" @click:row="fillCard">
                        <template v-slot:item.contractors="{ item }">
                            <span v-html="item.contractors"></span>
                        </template>
                        <template v-slot:item.shops="{ item }">
                            <span v-html="item.shops"></span>
                        </template>
                        <template v-slot:item.owner="{ item }">
                            <span v-if="item.owner == 1">Власник</span>
                        </template>
                        <template v-slot:no-data>
                            ...
                        </template>
                    </v-data-table>

                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

import {
    mapActions,
    mapGetters
} from 'vuex'

import {
    mask
} from "vue-the-mask"

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    directives: {
        mask
    },
    data() {
        return {
            ...mapGetters(['userInfo']),
            loading: false,
            items: [],
            search: null,
            select: null,
            f: {},
            usersTable: false,
            search: '',
            shops: [],
            successB: false,
            userData: {},
            footerProps: {
                'items-per-page-options': [10, 20],
                'items-per-page-text': 'на стор.'
            },
            headers: [{
                text: 'ID',
                align: 'left',
                sortable: true,
                value: 'member_id',
                selected: false,
                width: '5%',
            },
            {
                text: 'Телефон',
                align: 'left',
                sortable: true,
                value: 'phone',
                selected: true,
                width: '10%',
            },
            {
                text: 'ПІБ',
                align: 'left',
                sortable: true,
                value: 'name',
                selected: true,
                width: '20%',
            },
            {
                text: 'E-mail',
                align: 'left',
                sortable: true,
                value: 'email',
                selected: true,
                width: '15%',
            },
            {
                text: 'Тип',
                align: 'left',
                sortable: true,
                value: 'owner',
                selected: true,
                width: '10%',
            },
            {
                text: 'Контрагенти',
                align: 'left',
                sortable: true,
                value: 'contractors',
                selected: true,
                width: '20%',
            },
            {
                text: 'ТТ',
                align: 'left',
                sortable: true,
                value: 'shops',
                selected: true,
                width: '20%',
            },
            ]
        }
    },
    methods: {
        ...mapActions(['setSnackbar', 'getUserInfo', 'touch', 'getUsersList', 'getYoutvAvailList', 'getMemberData', 'buyYoutvPackageCodes', 'contractorsAutocomplete']),
        goBack() {
            window.history.state ? this.$router.go(-1) : this.$router.push('/adminpanel')
        },
        getUsers() {
            this.usersTable = true
            this.getDataFromApi()
        },
        getDataFromApi() {
            this.getUsersList()
        },
        fillCard() {
            this.usersTable = false
            this.getMemberData(this.userInfo().id)
                .then(data => {
                    this.shops = data.shops || []
                    this.userData = data.userData || {}

                    this.f = {
                        id: this.userData.id,
                        fio: this.userData.surname + ' ' + this.userData.firstname + ' ' + this.userData.lastname,
                        phone: this.userData.phone,
                        shops: data.shops,
                        contractor_id: null
                    }
                })
        },
        async sendForm() {
            const data = {
                packs: this.selectedPacks,
                ...this.f
            }
            this.buyYoutvPackageCodes(data)
                .then(data => {
                    if (data.error) {
                        this.setSnackbar(['error', data.error])
                        this.getYoutvAvailList(this.availList)
                    } else {
                        this.successB = true
                        this.getYoutvAvailList()
                    }
                })
                .catch(error => console.log(error))
        },
        querySelections(q) {
            this.loading = true
            if (q.length < 3) {
                this.loading = false
                return
            }
            this.contractorsAutocomplete({ q })
                .then(data => {
                    this.items = data
                    this.loading = false
                })
                .catch(error => {
                    this.loading = false
                    console.log(error)
                })
        },
    },
    created() {
        this.getUserInfo(this)
        this.getYoutvAvailList()
        this.fillCard()
    },
    computed: {
        list() {
            return this.$store.state.adminpanel.usersList
        },
        availList() {
            return this.$store.state.adminpanel.youtvAvailList || []
        },
        selectedPacks() {
            return this.availList.filter(el => el.cnt && el.cnt > 0)
        },
        wasSelectedPacks() {
            return this.availList.find(el => el.cnt && el.cnt > 0 && el.cnt <= el.avail)
        }
    },
    watch: {
        search(val) {
            val && val !== this.select && this.querySelections(val)
        },
    },
}
</script>

<style>
.inp-cnt {
    color: black;
    margin-left: 3px;
    margin-right: 3px;
    border: 1px solid rgb(7, 0, 0);
    width: 40px;
    text-align: center;
    padding: 1px;
    border-radius: 4px;
    box-sizing: border-box;
    background: #ffffff;
}
</style>
